<template>
    <layout-simple v-bind="$props">
        <layout-header
            @toggle-sidebar="toggleSidebar"
            :display-responsive-menu-on-desktop="displayResponsiveMenuOnDesktop"
            :responsive-menu-icon="responsiveMenuIcon"
            :responsive-sidebar-class="responsiveSidebarClass"
        >
            <slot name="header"></slot>

            <template v-slot:next-to-title>
                <slot name="header-next-to-title"></slot>
            </template>

            <template v-slot:responsive-sidebar>
                <slot name="header-sidebar"></slot>
            </template>
        </layout-header>
        <div :class="containerClass">
            <layout-apps-sidebar v-if="displayAppsSidebar" />

            <template v-if="! display.sidebar && $spa.getCurrentApp()">
                <div class="absolute h-[62px] left-[60px] z-100 flex items-center -ml-2">
                    <div class="flex items-center justify-center w-4 h-4 text-[10px] border border-gray-200 rounded-full cursor-pointer hover:bg-white bg-body hover:shadow text-slate-600 hover:text-slate-800" @click.prevent="toggleDesktopSidebar">
                        <i class="fas fa-chevron-right"></i>
                    </div>
                </div>
            </template>
            
            <layout-sidebar
                :sidebar-class="sidebarClass"
                :display-app-icon="displayAppIcon"
                :display-sidebar-toggle="displaySidebarToggle"
                @hide="toggleDesktopSidebar"
                v-if="display.sidebar"
            >
                <slot name="sidebar"></slot>
            </layout-sidebar>
            <layout-content
                :content-class="contentClass"
                v-if="display.content"
            >
                <div class="p-8 bg-white border-b border-gray-200" v-if="$spa.getCurrentApp() && ! $spa.getCurrentApp().displayed && appHasHiddenText">
                    <div class="flex flex-wrap items-center p-2 bg-gray-100 border-l-8 border-orange-600 rounded-lg shadow sm:justify-between md:p-3 lg:p-4">
                        <i class="mr-4 text-4xl text-orange-600 fal fa-exclamation-triangle"></i>
                        <p class="w-full text-xs sm:flex-1 text-slate-800 lg:text-sm">
                            {{ $t(`hidden_apps.${$spa.getCurrentApp().key}`) }}
                        </p>
                    </div>
                </div>
                <slot name="content"></slot>
            </layout-content>
        </div>
        <layout-modals />
    </layout-simple>
</template>

<script>
    import {
        LayoutHeader,
        LayoutModals,
        LayoutAppsSidebar,
        LayoutSidebar,
        LayoutContent,
        LayoutSimple
    } from "@spa/components/_Layout";

    export default {
        components: {
            LayoutHeader,
            LayoutModals,
            LayoutAppsSidebar,
            LayoutSidebar,
            LayoutContent,
            LayoutSimple
        },
        props: {
            layoutClass: {
                type: String,
                default() {
                    return this.$spa.css.layout.layout;
                }
            },
            containerClass: {
                type: String,
                default() {
                    return this.$spa.css.layout.container;
                }
            },
            contentClass: {
                type: String,
                default() {
                    return this.$spa.css.layout.content;
                }
            },
            sidebarClass: {
                type: String,
                default() {
                    return this.$spa.css.layout.sidebar;
                }
            },
            responsiveSidebarClass: {
                type: String,
                default() {
                    return this.$spa.css.layout.responsive_sidebar;
                }
            },
            displayResponsiveMenuOnDesktop: {
                type: Boolean,
                default: false
            },
            responsiveMenuIcon: {
                type: String,
                default: '/spa/close.svg'
            },
            handleSidebarDisplay: {
                type: Boolean,
                 default: true,
            },
            displayAppsSidebar: {
                type: Boolean,
                default: true
            },
            displayAppIcon: {
                type: Boolean,
                default: true
            },
            displaySidebarToggle: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                display: {
                    sidebar: true,
                    content: true
                }
            }
        },
        computed: {
            appHasHiddenText()
            {
                let key = `hidden_apps.${this.$spa.getCurrentApp().key}`;
                return this.$t(key) !== key;
            }
        },
        methods: {
            showSidebar() {
                if ( this.handleSidebarDisplay ) {
                    this.display.sidebar = true;
                    this.$emit('sidebar-displayed', true);
                }
            },
            hideSidebar() {
                if ( this.handleSidebarDisplay ) {
                    this.display.sidebar = false;
                    this.$emit('sidebar-hidden', false);
                }
            },
            toggleDesktopSidebar()
            {
                if ( this.displayResponsiveMenuOnDesktop ) {
                    return this.toggleResponsiveSidebar();
                }

                this.toggleSidebar();
            },
            toggleSidebar() {
                if ( this.handleSidebarDisplay ) {
                    this.display.sidebar = ! this.display.sidebar;
                    this.$emit('sidebar-toggled');
                } else {
                    this.$emit('sidebar-icon-clicked');
                }    
            }
        },
        created()
        {
            if ( this.$bus ) {
                this.$bus.$on('spa:toggleSidebar', () => {
                    this.toggleSidebar();
                });
                this.$bus.$on('spa:hideSidebar', () => {
                    this.hideSidebar();
                });
                this.$bus.$on('spa:showSidebar', () => {
                    this.showSidebar();
                });
            }
        }
    }
</script>
